var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[_c('v-draggable',{staticClass:"list-group",attrs:{"tag":"ul"},model:{value:(_vm.updatedList),callback:function ($$v) {_vm.updatedList=$$v},expression:"updatedList"}},[_c('transition-group',{attrs:{"type":"transition","name":'flip-list'}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }